import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

/**
 * Shared inline markdown renderer used across Title/Paragraph variants.
 * Renders block `p` as inline `span` and unwraps `div`, so the surrounding
 * element keeps full control of typography/layout.
 */
const inlineMarkdownComponents = {
  p: ({ node, ...props }: any) => <span {...props} />,
  div: React.Fragment,
};

export function InlineMarkdown({ children }: { children: any }) {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={inlineMarkdownComponents as any}
    >
      {children}
    </ReactMarkdown>
  );
}

/** Text-align class shared by Paragraph and ParagraphNumber. */
export function paragraphAlignClass(layout?: string, card?: string): string {
  switch (layout) {
    case "left":
    case "right":
      return card === "featured" ? "text-center lg:text-left" : "text-left";
    case "center":
      return "lg:text-center";
    case "fixedCenter":
      return "text-center";
    default:
      return "";
  }
}
